// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zLZta8BfhfcMm4UtCnL8{padding:24px 0 24px 24px;position:relative}.xhBtmGHAzDkbY90tISPv{flex-direction:column;gap:4px;display:flex}.xhBtmGHAzDkbY90tISPv:not(:empty){padding-bottom:20px}.xJ6paWMd4UyYzI3_pZsL{margin-bottom:12px;padding:0}.xJ6paWMd4UyYzI3_pZsL input{height:18px;font-size:16px}.xJ6paWMd4UyYzI3_pZsL input:disabled{color:var(--content-primary-primary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `zLZta8BfhfcMm4UtCnL8`,
	"alertContainer": `xhBtmGHAzDkbY90tISPv`,
	"textField": `xJ6paWMd4UyYzI3_pZsL`
};
export default ___CSS_LOADER_EXPORT___;
